import { render, staticRenderFns } from "./CompanyAddModal.vue?vue&type=template&id=a6f81a84&"
import script from "./CompanyAddModal.vue?vue&type=script&lang=js&"
export * from "./CompanyAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports